// extracted by mini-css-extract-plugin
export var buttons = "T_cp";
export var column = "T_cc";
export var columns = "T_cb";
export var container = "T_h";
export var down = "T_dg";
export var download = "T_df";
export var footer = "T_cS";
export var information = "T_dd";
export var section = "T_j";
export var show = "T_L";
export var text = "T_cl";
export var title = "T_d";
export var units = "T_dh";
export var up = "T_dk";
export var upload = "T_dj";
export var waveOne = "T_q";
export var waveThree = "T_cH";
export var waveTwo = "T_n";
export var waves = "T_cG";